// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"38a5f788","323":"216faa32","522":"fa2c4268","598":"b04b67c6","605":"01c4dba1","673":"1c19267a","694":"3716c4cc","790":"38a5f788"}[chunkId] + ".chunk.css";
};